import { httpRequest } from "../../http";
import { Todo } from "@models/todo.model";
import { TodoSerializer } from "@models/serializers/todoSerializer";

export class CommandListMyTodos {
  async run(userId: number): Promise<Todo[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/todos/?assigned_to=${userId}`;
    const response = await httpRequest<any[]>(url, { method: "GET" });
    const serializer = new TodoSerializer();
    return (response ?? []).map((entry) => serializer.deserialize(entry));
  }
}
